import ToggleDeclaration from "./ToggleDeclaration";

const HazardousDeclaration = () => {
  return (
    <ToggleDeclaration
      title="Lab Safety Declaration"
      toggleLabel="I will not bring any hazardous materials into the labs."
      toggleSubtext="Hazardous materials include but are not limited to: samples containing infectious agents like viruses, bacteria, fungi, parasites, or prion proteins."
      fieldName="hasHazardousMaterials"
      textFieldName="hazardousMaterialsText"
      textareaPlaceholder="Please list any potentially hazardous materials you plan to bring into the lab, or switch the toggle to confirm that you are not bringing any hazardous materials. *"
      toggleType="slide"
      invertToggleLogic={true}
      alwaysShowTextarea={false}
    />
  );
};

export default HazardousDeclaration;
